import { Package, Tags } from "lucide-react";

type QuotationDetailMode = "official" | "manual";

interface QuotationDetailModeToggleProps {
  activeMode: QuotationDetailMode;
  onChange: (mode: QuotationDetailMode) => void;
}

export function QuotationDetailModeToggle({
  activeMode,
  onChange,
}: QuotationDetailModeToggleProps) {
  return (
    <nav
      aria-label="Modos da cotação"
      className="lnk-mode-toggle quotation-mode-toggle"
    >
      <button
        type="button"
        className={`quotation-mode-tab ${activeMode === "manual" ? "active" : ""}`}
        onClick={() => onChange("manual")}
        aria-pressed={activeMode === "manual"}
      >
        <Tags size={18} /> AVULSOS
      </button>
      <button
        type="button"
        className={`quotation-mode-tab ${activeMode === "official" ? "active" : ""}`}
        onClick={() => onChange("official")}
        aria-pressed={activeMode === "official"}
      >
        <Package size={18} /> OFICIAIS
      </button>
    </nav>
  );
}

export type { QuotationDetailMode };
